import {styled} from '@vw-marketing/us-components';

export const StyledBrochureWrapper = styled.div`
  width: max-content;
  display: flex;
`;

export const StyledText = styled.div`
  font-size: 16px;
  font-weight: 700;
  line-height: 20px;
  font-family: 'vw-text', Helvetica, Arial, sans-serif;
  display: flex;
  align-items: flex-end;

  a {
    cursor: pointer;
  }
`;
